import { useInView } from "@/hooks/useInView";

/**
 * Scroll-triggered subtle fade + rise.
 * Usage: <Reveal><section>...</section></Reveal>
 * Optional `delay` in ms staggers child reveals.
 */
const Reveal = ({
  children,
  delay = 0,
  as: Tag = "div",
  className = "",
  threshold = 0.12,
}) => {
  const [ref, inView] = useInView({ threshold });
  return (
    <Tag
      ref={ref}
      className={`reveal ${inView ? "reveal-in" : ""} ${className}`}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
